<template>
  <div class="content">
    <div style="margin-bottom: 22px">
      <div class="row1">
        <span class="label1">{{ $t("totalPaymentAmount") }}</span>
        <span class="value1">
          {{ formatNumber(billDetail?.payment_amount) }} đ</span
        >
      </div>
    </div>
    <div
      v-if="$route.query.status == 3 && billDetail?.payment_code"
      style="margin-top: -30px; margin-bottom: 15px"
    >
      <el-button
        :disabled="isDisabled"
        :loading="loadingSubmit"
        @click="handlePayment"
        class="button-pay"
        >{{ $t("payment") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@/plugins/init";
import { getBackGround } from "@/utils/wapAuth";

export default {
  components: {}, //, Comment
  bodyClass: "info-payment",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    loadingSubmit: {
      type: Boolean,
      default: false
    },
    billDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bg: getBackGround()
    };
  },
  created() {},

  watch: {},

  methods: {
    formatNumber,
    handlePayment() {
      this.$emit("on-action-payment", { reload: true });
    }
  },
  computed: {},
  mounted() {},

  beforeDestroy() {}
};
</script>
<style></style>
<style lang="scss" scoped>
.header-top {
  padding-top: 100px;
}

.box-header {
  display: flex;
  padding: 10px;
  align-items: center;
}

.checkbox {
  margin-left: 2px;
}

.title {
  font-size: 14px;
  font-weight: 600;
}

.quantity,
.status {
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.content {
  margin-right: 12px;
  margin-left: 12px;
}

.row1 {
  width: 100%;
  display: flex;
  //margin-bottom: ;
  justify-content: space-between;
}

.label1 {
  font-size: 16px;
  font-weight: 600;
}
.label2 {
  font-size: 14px;
  font-weight: 400;
}

.value1 {
  font-size: 16px;
  font-weight: 600;
  color: #fb7800;
}
.value2 {
  font-size: 14px;
  font-weight: 400;
  color: #0095da;
}

.button-pay {
  padding: 0 !important;
  width: 100%;
  height: 40px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  border-radius: v-bind("bg.b_radius1") !important;
  background: v-bind("bg.c_button_main") !important;
  color: #ffffff !important;
}

.column-wrapper {
  display: flex;
  justify-content: flex-end;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 0px) and (max-width: 769px) {
}

.mt-0 {
  margin-top: 0 !important;
}

.text-bold {
  font-weight: bold !important;
}
.color-price {
  color: #fb7800;
}
.align-center {
  align-items: center !important;
}

.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between !important;
}

.pointer {
  cursor: pointer;
}

.border-1 {
  border: 1px solid #ababab;
  border-radius: 10px;
}

.icon-image {
  height: 30px !important;
}

.text-not-break {
  word-break: keep-all !important;
}
</style>
